import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { toast } from 'sonner';

export default function Grupos() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    API.get('/catalogs/groups').then(res => setItems(res.data)).catch(() => toast.error('Error'));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Grupos</h1>
        <p className="text-sm text-muted-foreground">Grupos de acumuladores y capacidades de tarima</p>
      </div>
      <Card className="bg-white border"><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow className="bg-muted/30">
            <TableHead>Código</TableHead><TableHead>Descripción</TableHead><TableHead className="text-right">Capacidad Tarima</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map(g => (
              <TableRow key={g.id} className="hover:bg-muted/40">
                <TableCell className="font-medium font-mono">{g.codigo}</TableCell>
                <TableCell>{g.descripcion}</TableCell>
                <TableCell className="text-right font-semibold">{g.capacidad_tarima} pzas</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
